import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Box } = designSystem;

function ContentBox({ children }) {
  return (
    <div className="ws-website-design-dialog__content-box">
      <Box
        paddingTop="spacing-s"
        paddingBottom="spacing-s"
        paddingLeft="spacing-m"
        paddingRight="spacing-m"
      >
        {children}
      </Box>
    </div>
  );
}

ContentBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ContentBox;
